<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_3"><span class="bold">Hadon of Ancient Opar</span></a></h1><a id="page_3">
<p class="author">Philip José Farmer</p>
<p class="author"><img alt="image" src="images/logo.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Title.vue?2bdfd66d